import { jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
var AppVersion = function () {
    var appGitVersion = process.env.REACT_APP_CARE_PORTAL_GIT_VERSION;
    var appVersion = '3.12.0';
    return (_jsxs(Typography, { component: "div", variant: 'h5', "data-testid": 'app-version', children: ["Version ", "".concat(appVersion)] }));
};
export default AppVersion;
